// A janela não rola neste app: `html, body` são `overflow: hidden` (public/index.html)
// e quem rola é o #root — ou, nas páginas com PageContainer de altura fixa (wizard de
// requerimentos, protocolos, pendências...), o próprio PageContainer. Por isso
// `window.scrollTo` não faz nada; isto rola todos os candidatos de uma vez.
// Contêineres de página entram marcando o elemento com `data-rolagem-pagina`.
export const rolarParaTopo = ({ behavior = 'smooth' } = {}) => {
  const alvos = [
    document.scrollingElement,
    document.getElementById('root'),
    ...document.querySelectorAll('[data-rolagem-pagina]')
  ];
  alvos.forEach(alvo => alvo?.scrollTo?.({ top: 0, behavior }));
};
